import { observable, action, runInAction, toJS } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import Service from '@service/index';

const moSingle = observable({
  industryList: <any[]>[],
  currentIndustry: <any>[],
  code: <number | string>'',
  name: '',
  isModal: false,
});

const industryInit = action(() => {
  const industryName = localStorage.getItem('regIndustry') || '';
  const arr: any = cloneDeep(moSingle.industryList);
  let code: number | string = '';
  let currentArr: any[] = [];

  arr.map((item: any) => {
    item.sub_industries.map((child: any) => {
      if (child.name === industryName) {
        code = child.code;
        currentArr = item.sub_industries;
      }
    });
  });

  moSingle.currentIndustry = currentArr;
  moSingle.industryList = arr;
  moSingle.code = code;
  moSingle.name = industryName;
});

// 获取行业数据
const getIndustry = action(async () => {
  const res: any = await Service.info();
  // console.log('行业数据 -- ', res.industry);
  if (isEmpty(res)) return;

  res.industry.map((item: any) => {
    item.info.active = false;
    item.sub_industries.map((child: any) => { child.active = false; });
  });
  runInAction(() => {
    moSingle.industryList = res.industry;

    industryInit();
  });
});

// 选择一级行业
const changeIndustry = action((code: number | string, name: string) => {
  // console.log('选择一级行业 -- ', name);
  const arr: any[] = cloneDeep(moSingle.industryList);
  let currentArr: any[] = [];
  arr.map((item: any) => {
    if (item.info.code === code) {
      item.info.active = true;
      currentArr = item.sub_industries;
    } else {
      item.info.active = false;
      item.sub_industries.map((child: any) => { child.active = false; });
    }
  });
  moSingle.currentIndustry = currentArr;
  moSingle.industryList = arr;
});

// 关闭弹框时，重置弹框高亮
const resetIndustryActive = action(() => {
  const { code } = moSingle;
  const arr: any[] = cloneDeep(moSingle.industryList);
  let currentArr: any[] = [];
  arr.map((item: any) => { item.info.active = false; });
  arr.map((item: any) => {
    item.sub_industries.map((child: any) => {
      if (child.code === code) {
        item.info.active = true;
        child.active = true;
        currentArr = item.sub_industries;
      }
    });
  });
  moSingle.industryList = arr;
  moSingle.currentIndustry = currentArr;
});

// 触发弹框
const toggleModal = action((value: boolean) => {
  moSingle.isModal = value;
  // 关闭弹框时，重置弹框高亮
  if (!value) resetIndustryActive();
});

// 选择二级行业
const changeSubIndustry = action((code: number | string, name: string) => {
  // console.log('选择二级行业 -- ', name);
  const arr: any[] = cloneDeep(moSingle.currentIndustry);
  arr.map((item: any) => {
    if (item.code === code) item.active = true;
    else item.active = false;
  });
  moSingle.code = code;
  moSingle.name = name;
  moSingle.currentIndustry = arr;
  toggleModal(false);
});

export default moSingle;
export {
  getIndustry, changeIndustry, changeSubIndustry,
  toggleModal, industryInit,
};
